import cn from 'classnames';
import styles from './UserComment.module.scss';
import { UserType } from '@/types';

type UserCommentProps = {
  className?: string;
  isAnonymous: boolean;
  user?: UserType | null;
};

export function UserComment({
  className,
  isAnonymous,
  user,
}: UserCommentProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <>
      {!user && (
        <div className={wrapperClassName}>
          <span className={styles.userName}>Аноним</span>
        </div>
      )}
      {user && isAnonymous && (
        <div className={wrapperClassName}>
          <span className={styles.userName}>Профиль скрыт пользователем</span>
        </div>
      )}
      {user && !isAnonymous && (
        <div className={wrapperClassName}>
          <span className={styles.userName}>
            {user.name} {user.lastName && `${user.lastName.slice(0, 1)}.`}
          </span>
        </div>
      )}
    </>
  );
}
